<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control">
        <ejs-dropdownbutton
            :name="config.name"
            :cssClass="config.cssClass"
            :iconCss="config.iconCss"
            :id="dataTestId"
            :realId="config.realId"
            :items="options"
            v-on:click="action($event, 'onclick')"
            v-on:select="select($event)"
            :ref="config.ref || config.id"
            :data-test-id="dataTestId"
            :beforeOpen="beforeOpen"
            :open="open"
            @created="created($event)"
            :beforeItemRender="beforeItemRender"
            :disabled="config.disabled"
        ><span v-html="config.label"></span></ejs-dropdownbutton>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {
    defaultItems: {
        label: 'Default items',
        type: 'ARRAY',
        id: 'defaultItems',
        itemConfig: {
            primaryKey: 'text',
            itemType: 'object',
            permissions: {
                allowAddItem: true,
            },
            keys: {
                text: {
                    type: 'string',
                    label: 'Text'
                },
                value: {
                    type: 'string',
                    label: 'Value'
                },
            },
            newItem: {
                text: '',
                value: ''
            }
        },
        helpText: 'Tests to show how array of objects function'
    },
};

export const dropdownButtonComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    watch: {
        'value': function () {
            this.setLabelFromOption();
        },
        'options': function (newValue) {
            if (newValue.length) this.setLabelFromOption();
        }
    },
    methods: {
        beforeItemRender(args) {
            if (args?.item?.template) args.element.innerHTML = args.item.template;
            if (args?.item?.height) args.element.style.height = args.item.height;
        },
        select($event) {
            this.value = $event.item.value;
            this.action($event, 'onselect');
        },
        setLabelFromOption() {
            if (!this.config.useSelectedOptionAsLabel) return;
            let selectedOption = this.options.find((item) => item.value === this.value);
            if (selectedOption) {
                this.config.label = selectedOption[this.config.fields.text];
            }
        },
        open($event) {
            this.action($event, 'onopen');
        },
        beforeOpen() {
            if (this.config) {
                let ref = this.config.ref || this.config.id;
                if (ref) {
                    let width = this.$refs[ref].ej2Instances.element.offsetWidth;
                    this.$refs[ref].ej2Instances.dropDown.element.style['min-width'] = width + "px";
                }
            }
        },
        created() {
            if (this?.config?.caretCss) {
                let caretEl = this.$el.getElementsByClassName('e-caret')?.[0];
                if (caretEl?.classList) {
                    let tmpClasses = this.config.caretCss.split(' ');
                    for (let i in tmpClasses) {
                        caretEl.classList.add(tmpClasses[i]);
                    }
                    caretEl.classList.remove('e-caret');
                    caretEl.classList.remove('e-icons');
                }
            }
        }
    },
    components: {
        "ejs-dropdownbutton": defineAsyncComponent(() => import('@common/syncfusion/dropdownButton'))
    }
};

export default dropdownButtonComponent;
</script>
